import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../auth/AuthProvider';
import { getUsage } from './client';
import { keys } from './keys';

/**
 * Fetch this period's usage (D13-07) — your figures + the org aggregate, off
 * the D13-05 `GET /api/v1/workstreams/usage` endpoint. Mirrors {@link useWorkstreams}.
 *
 * Loading + error states are surfaced via React Query's standard fields;
 * errors are also routed to `reportError` through the shared
 * `QueryCache.onError` sink (queryClient.ts).
 */
export function useUsage() {
  const { getAccessToken } = useAuth();
  return useQuery({
    queryKey: keys.usage.mine(),
    queryFn: ({ signal }) => getUsage({ getAccessToken, signal }),
  });
}
